<!--申请人信息-->
<template>
  <div class="module">
    <h5 class="module-title">申请人信息</h5>
    <div class="module-tips">申请人只能为易派客管理员，请补充相关信息</div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="申请人：" prop="name" label-width="96px">
            {{ defaultForm?.creatorRealName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="易派客用户名：" prop="region">
            {{ defaultForm?.creator }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="证件信息："
            :prop="`settleAccountAttachTempList[${getIndexByFileType(
              'AC'
            )}].certificateNo`"
            :rules="rules.certificateNo"
            label-width="96px"
            class="document-information"
          >
            <el-select
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('AC')]
                  .certificateType
              "
              placeholder="请选择"
            >
              <el-option
                v-for="item in certificateTypeList"
                :key="item.itemCode"
                :label="item.itemDisp"
                :value="item.itemCode"
              ></el-option>
            </el-select>
            <el-input
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('AC')]
                  .certificateNo
              "
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="证件有效期："
            :prop="`settleAccountAttachTempList[${getIndexByFileType(
              'AC'
            )}].certificateTimeRange`"
            label-width="96px"
            class="period-of-validity"
          >
            <el-date-picker
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('AC')]
                  .certificateTimeRange
              "
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :disabled="createrDateDisabled"
            >
            </el-date-picker>
            <el-checkbox
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('AC')]
                  .certificateLongValid
              "
              @change="radioChange('AC')"
              >长期有效
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="证件复印件："
            prop="applyCertificate"
            :rules="rules.attachPath"
            label-width="96px"
          >
            <div class="flex">
              <eui-upload
                ref="euiUpload1"
                key-name="applicantCertificatePath"
                :file-list="fileList.AC"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                accept=".jpg,.png"
                single
                text="上传附件"
                @handleSuccess="() => uploadSuccess('AC', fileList.AC)"
              >
              </eui-upload>
              <eui-btn type="secondary" @click="previewUploadFile(fileList.AC)"
                >预览
              </eui-btn>
              <span
                >请上传身份证证件两面清晰的扫描或复印件，并加盖公司红色公章，限≤2mb，jpg、png格式。</span
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="授权书："
            prop="applyEmpower"
            :rules="rules.attachPath"
            label-width="96px"
          >
            <div>1.下载授权书模板：</div>
            <div style="margin-top: -10px" class="gray-color">
              <span
                style="color: #0064c8; cursor: pointer"
                @click="downloadTemplate()"
                >点击下载《申请人授权书模板》</span
              >
              下载后填写相关信息，申请人签字、加盖公章，并扫描后上传
            </div>
            <div>2.上传扫描件：</div>
            <div class="flex">
              <eui-upload
                ref="euiUpload2"
                :file-list="fileList.AA"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                single
                accept=".jpg,.png,.pdf"
                text="上传文件"
                :picure-width="200"
                tip="请上传清晰的扫描或复印件并加盖公司公章(红色)。限≤2mb，jpg、png、pdf格式"
                @handleSuccess="() => uploadSuccess('AA', fileList.AA)"
              >
              </eui-upload>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import {
  paymentAccountOpeningMixins,
  commonMethodsMixins,
  downloadTemplateUrl,
} from '../constant';
import ViewerImage from '../components/viewerImage';

export default {
  name: 'ApplicationInfo',
  components: { ViewerImage },
  mixins: [paymentAccountOpeningMixins, commonMethodsMixins],
  data() {
    return {
      ruleForm: {
        settleAccountAttachTempList: [
          {
            attachName: '',
            attachPath: '',
            attachType: 'AC',
            certificateBeginTime: '',
            certificateEndTime: '',
            certificateTimeRange: [],
            certificateLongValid: '',
            certificateNo: '',
            certificateType: 0,
          },
          {
            attachName: '',
            attachPath: '',
            attachType: 'AA',
            certificateBeginTime: '',
            certificateEndTime: '',
            certificateLongValid: '',
            certificateNo: '',
            certificateType: 0,
          },
        ],
      },
      fileList: {
        AC: [],
        AA: [],
      },
      createrDateDisabled: false,
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData(sourceData, defaultForm) {
      this.defaultForm = Object.assign(this.defaultForm, defaultForm);
      if (!sourceData?.settleAccountAttachTempList) {
        return;
      }
      this.ruleForm.settleAccountAttachTempList.forEach((attachItem, index) => {
        const tempObj = sourceData.settleAccountAttachTempList.find(
          (tempItem) => tempItem.attachType === attachItem.attachType
        );
        if (tempObj) {
          Object.keys(attachItem).forEach((key) => {
            attachItem[key] = tempObj[key] ?? attachItem[key];
          });
          // 附件回显
          if (attachItem?.attachName && attachItem?.attachPath) {
            this.fileList[attachItem.attachType].push({
              name: attachItem.attachName,
              url: attachItem.attachPath,
            });
          }
          if (attachItem.attachType === 'AC') {
            attachItem.certificateTimeRange =
              attachItem.certificateBeginTime && attachItem.certificateEndTime
                ? [
                    attachItem.certificateBeginTime,
                    attachItem.certificateEndTime,
                  ]
                : [];
          }
          attachItem.certificateLongValid = !!attachItem.certificateLongValid;
          this.$set(
            this.ruleForm.settleAccountAttachTempList,
            index,
            attachItem
          );
        }
      });
      console.log(this.ruleForm, 'applicant init');
      this.radioChange('AC');
    },
    // 下载模板
    async downloadTemplate() {
      const path = `${downloadTemplateUrl}/%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E6%9D%BF.doc`;
      window.open(path);
    },
    // 法人和申请人附件上传
    uploadSuccess(certificateType, attachObj) {
      this.reUploadFlag = true;
      const tempObj = this.ruleForm.settleAccountAttachTempList.find(
        (attach) => attach.attachType === certificateType
      );
      if (tempObj) {
        this.$set(tempObj, 'attachName', attachObj[0]?.response?.data.fileName);
        this.$set(tempObj, 'attachPath', attachObj[0]?.response?.data.url);
        if (certificateType === 'AA' || certificateType === 'AC') {
          Api.addEpaySettleAccountApplicantAttach({
            attachName: attachObj[0]?.response?.data.fileName,
            attachPath: attachObj[0]?.response?.data.url,
            attachType: certificateType,
          });
        }
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
